import { z } from 'zod/v4';

export const CrmTagContract = z.object({
    id: z.number(),
    name: z.string(),
    colorText: z.string(),
    colorBackground: z.string(),
    contactCount: z.number(),
    taskCount: z.number(),
});

export const CrmTagCollectionResponseSchema = z.object({
    data: z.array(CrmTagContract),
});

export type CrmTag = z.infer<typeof CrmTagContract>;
